/**
 * Vector map ID required for {@link google.maps.marker.AdvancedMarkerElement}.
 * Set GOOGLE_MAPS_VECTOR_MAP_ID in the build environment using a Map ID created in the
 * same GCP project as GOOGLE_MAP_API_KEY. Leave empty to disable vector map ID.
 */
export const GOOGLE_MAPS_VECTOR_MAP_ID = (process.env.GOOGLE_MAPS_VECTOR_MAP_ID || '').trim();
export const GOOGLE_MAPS_VECTOR_MAP_ID_LIGHT = (process.env.GOOGLE_MAPS_VECTOR_MAP_ID_LIGHT || '').trim();
export const GOOGLE_MAPS_VECTOR_MAP_ID_DARK = (process.env.GOOGLE_MAPS_VECTOR_MAP_ID_DARK || '').trim();
